export default __webpack_public_path__ + "static/media/279.8764e4ad.png";